'use strict';

module.exports = function dump() {
  console.log(this.items);
  return this;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/dump.js
// module id = 1219
// module chunks = 2